import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';
import { Icon } from '@iconify/react';

import { MenuItem, ListItemIcon, ListItemText } from '@mui/material';

import { editItem, getItem, deleteItemWithBody } from '../../fetch';
import { useEffectAsync } from '../../reactHelper';
import { useTranslation } from '../../common/LocalizationProvider';
import { PermissionDialog } from '../permission';
import { usersActions } from '../../store';
import { selectGroupsArray, selectUsersArray } from '../../createSelectorUtils';

UserLinkedClub.propTypes = {
  userId: PropTypes.number.isRequired
};
export default function UserLinkedClub({ userId }) {
  const t = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();

  const groups = useSelector(selectGroupsArray);
  const user = useSelector(selectUsersArray).find((user) => user.id === userId);

  const [linkedClub, setLinkedClub] = useState([]);
  const [permissionClub, setPermissionClub] = useState(user ? user.permission || [] : []);

  const [isOpen, setIsOpen] = useState(false);

  useEffectAsync(async () => {
    if (isOpen) {
      const response = await getItem(`groups?userId=${userId}`);
      if (response.ok) {
        setLinkedClub(await response.json());
      }
    }
  }, [isOpen]);

  const handleChangeStatus = async (id, status) => {
    const newPermissionClub = permissionClub.map((item) =>
      item.groupid === id ? { ...item, status } : item
    );
    if (newPermissionClub.find((item) => item.groupid === id) === undefined) {
      newPermissionClub.push({ userid: userId, groupid: id, status });
    }
    setPermissionClub(newPermissionClub);
  };
  const handleChange = async (event) => {
    const newGroup = groups.find((group) => group.id === parseInt(event.target.value, 10));
    const status = permissionClub.find((item) => item.groupid === newGroup.id)?.status ?? -1;
    if (newGroup && status !== -1) {
      const create = !linkedClub.map((item) => item.id).includes(newGroup.id);
      const response = create
        ? await editItem('permissions', undefined, {
            userId,
            groupId: newGroup.id,
            status
          })
        : await deleteItemWithBody('permissions', {
            userId,
            groupId: newGroup.id,
            status
          });
      if (response.ok) {
        setLinkedClub(
          create ? [...linkedClub, newGroup] : linkedClub.filter((item) => item.id !== newGroup.id)
        );
        dispatch(usersActions.update([{ ...user, permission: permissionClub }]));
      } else {
        const error = await response.text();
        const message = error.slice(0, error.indexOf('-'));
        enqueueSnackbar(message, { variant: 'error' });
      }
    } else if (status === -1) {
      enqueueSnackbar('Please chose status', { variant: 'error' });
    }
  };

  return (
    <>
      <MenuItem sx={{ color: 'text.secondary' }} onClick={() => setIsOpen(true)}>
        <ListItemIcon>
          <Icon icon="carbon:group-objects" width={24} height={24} />
        </ListItemIcon>
        <ListItemText
          primary={t('UL_Menu_Linked_Clubs')}
          primaryTypographyProps={{ variant: 'body2' }}
        />
      </MenuItem>

      <PermissionDialog
        title="UL_Menu_Linked_Clubs"
        open={isOpen}
        onClose={() => setIsOpen(false)}
        handleChange={handleChange}
        allObject={groups}
        linkedObject={linkedClub}
        permissionClub={permissionClub}
        handleChangeStatus={handleChangeStatus}
      />
    </>
  );
}
